import { observer } from 'mobx-react';
import * as React from 'react';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { AnalyticsStore, ContextStore, ExperimentStore } from 'bernie-core';
import { ILocalization } from 'bernie-l10n';
import { PageData } from 'bernie-http';
import { ViewMedium, Viewport, ViewSmall } from 'bernie-view';

import { MultiItemStore } from 'stores/multi-item-store';

import { MitStep } from 'models/multi-item/multi-item-types';

import { LegacyMultiItemStepIndicator } from 'components/multi-item/legacy-step-indicator';
import { MitMessageHeader } from 'components/multi-item/multi-item-message-header';
import { StepIndicator } from 'components/multi-item/step-indicator';

export type MitHeaderProps = {
  currentStepName: MitStep;
  multiItem?: MultiItemStore;
  experiment?: ExperimentStore;
  context?: ContextStore;
  page?: PageData;
  analytics?: AnalyticsStore;
  l10n: ILocalization;
};

export const MitHeader: React.FunctionComponent<MitHeaderProps> = observer(['multiItem', 'analytics'], props => {
  const { multiItem, currentStepName, analytics, l10n } = props;
  if (multiItem && multiItem.isPackageShoppingPath()) {
    const multiItemSessionId = multiItem.multiItemSessionId;

    return (
      <AbacusExperiment name="MIT_PWA_Step_Indicator_Playback">
        <AbacusControl>
          <LegacyMultiItemStepIndicator l10n={l10n} multiItem={multiItem} currentStepName={currentStepName} />
          <Viewport>
            <ViewSmall>
              <MitMessageHeader l10n={l10n} localizedMessage={'multiItem.stepIndicator.hotel'} />
            </ViewSmall>
            <ViewMedium>
              <MitMessageHeader l10n={l10n} localizedMessage={'multiItem.hsrTitle.hc'} />
            </ViewMedium>
          </Viewport>
        </AbacusControl>
        <AbacusVariant bucket={1}>
          <StepIndicator {...{ multiItemSessionId, analytics }} />
        </AbacusVariant>
      </AbacusExperiment>
    );
  }

  return null;
});

MitHeader.displayName = 'MitHeader';
